import useDebounce from 'react-use/lib/useDebounce';
import { useDeviceType } from './useDeviceType';

export const useDebouncedDeviceType = onChange => {
  const media = useDeviceType();

  useDebounce(
    () => {
      onChange(media);
    },
    400,
    [media.phone, media.tablet, media.desktop, media.phoneLandscape]
  );
};
